import React,{useState} from "react"
import ColorTheme from "./utils/colors";
import ThemeContext from "./context"
import Header from "./header";
import Content from "./content";
import Footer from "./footer";

const App = () => {
  const [theme, setTheme] = useState(
    localStorage.getItem("theme") !== null
      ? localStorage.getItem("theme")
      : "light"
  );
  const value = { theme, setTheme };
  const colortheme = theme === "light" ? ColorTheme.light : ColorTheme.dark;
  return (
    <div className="h-[100vh] flex flex-col items-center justify-between" style={{
      backgroundColor: colortheme.background,
      color: colortheme.color
    }}>
    <ThemeContext.Provider value={value}>
      <Header/>
      <Content/>
      <Footer/>
    </ThemeContext.Provider>
    </div>
  );
}

export default App;
